import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b463171"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  disabled: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BotoesEdicao = _resolveComponent("BotoesEdicao")!

  return (_openBlock(), _createElementBlock("article", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selecionar && _ctx.selecionar(...args)))
  }, [
    _createElementVNode("header", null, [
      _createTextVNode(_toDisplayString(_ctx.questao.getIndice()) + " - " + _toDisplayString(_ctx.questao.getTitulo()) + " ", 1),
      _createVNode(_component_BotoesEdicao, {
        ehPrimeiro: _ctx.ehPrimeiro,
        ehUltimo: _ctx.ehUltimo,
        onEditar: _ctx.editar,
        onExcluir: _ctx.excluir,
        onDescer: _ctx.descer,
        onSubir: _ctx.subir
      }, null, 8, ["ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"])
    ]),
    _createElementVNode("fieldset", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.questao.getListaOpcoes() as ListaEditavel<OpcaoEditavel>).getItens(), (opcao) => {
        return (_openBlock(), _createElementBlock("label", {
          key: opcao.getId().toString()
        }, [
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(opcao.getTitulo()), 1)
        ]))
      }), 128))
    ])
  ]))
}